export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: '100vh',
    },
    cardContainer: {
        padding: '20px 20px 0px 20px'
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    mainHeadingText: {
        fontSize: theme.typography.h4,
        fontWeight: 600
    },
    card: {
        height: '100%',
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DEDEDE'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        color: theme.palette.text.primary,
    },
    cardBody: {
        marginTop: '10px',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        color: theme.palette.text.primary,
    },
    cardFooter: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    cardHeadingText: {
        fontSize: theme.typography.h6,
        fontWeight: 600,
        wordBreak: 'break-word'
    },
    cardDescriptionText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
        wordBreak: 'break-word'
    },
    integrateBtn: {
        backgroundColor: '#0B51C5',
        borderRadius: '20px',
        color: "#FFFFFF",
        width: '100px'
    },
    integrateBtnText: {
        fontSize: '14px',
        fontWeight: '600',
    },
    btnText: {
        fontSize: '14px',
        fontWeight: '600',
    }
})